import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BuildingProvider } from "@/context/BuildingContext";
import { Toaster } from "@/components/ui/sonner";
import { SpinnerGap } from "@phosphor-icons/react";
import Home from "@/pages/Home";
import ReportNew from "@/pages/ReportNew";
import ReportsList from "@/pages/ReportsList";
import ReportTrack from "@/pages/ReportTrack";
import Cleaning from "@/pages/Cleaning";
import Services from "@/pages/Services";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Infos from "@/pages/Infos";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="auth-loading">
        <SpinnerGap size={32} className="animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.1 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BuildingProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/signaler" element={<ReportNew />} />
              <Route path="/signalements" element={<ReportsList />} />
              <Route path="/suivi/:ref" element={<ReportTrack />} />
              <Route path="/entretien" element={<Cleaning />} />
              <Route path="/services" element={<Services />} />
              <Route path="/infos" element={<Infos />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <Protected>
                    <AdminDashboard />
                  </Protected>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </BuildingProvider>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
